import http from "../../services/httpService";

// Base URL for the notes endpoint
// Ensure this matches the route registered in your Django urls.py
const NOTES_API_URL = "/notes/api/notes";

const notesApiService = {
    /**
     * Fetch all notes for a specific concept
     * @param {number|string} conceptId 
     */
    fetchNotes: (conceptId) => {
        return http.get(`${NOTES_API_URL}/`, {
            params: { concept: conceptId } // Use the key your Django backend expects (e.g., 'concept' or 'concept_id')
        });
    },

    /**
     * Create a new note
     * @param {Object} noteData 
     */
    addNote: (noteData) => {
        return http.post(`${NOTES_API_URL}/`, noteData);
    },

    /**
     * Update an existing note
     * @param {number|string} noteId 
     * @param {Object} noteData 
     */
    updateNote: (noteId, noteData) => {
        return http.patch(`${NOTES_API_URL}/${noteId}/`, noteData);
    },

    /**
     * Delete a note
     * @param {number|string} noteId 
     */
    deleteNote: (noteId) => {
        return http.delete(`${NOTES_API_URL}/${noteId}/`);
    }
};

export default notesApiService;